import React from "react";
import { Switch, Button } from "@mui/material";
import ResetControlsIcon from "./controlIcons/resetControls.png";
import IconJawStateOpen from "./controlIcons/controlsJawStateOpen.png";
import IconTop from "./controlIcons/controlsTop.png";
import IconBottom from "./controlIcons/controlsBottom.png";
import IconTransparency from "./controlIcons/transparency.png";
import IconHeadMask from "./controlIcons/controlsHeadMask.png";
import "./index.scss";
import { useTranslation } from "../../../i18n";

const Formula3DPreviewControls = ({
  isFullScreen,
  switchers,
  setSwitchers,
  // availableSides,
  setAvailableSides,
  modelTransparency,
  setModelTransparency,
  jawState,
  toggleJawState,
  hideJawStateSwitcher = true,
  headMask,
  toggleHeadMask,
  hideHeadMaskSwitcher = true,
  hideSidesSwitchers = false,
  resetControls
}) => {
  const {
    _t
  } = useTranslation();

  function onChange(e) {
    let name = e.target.name; // let checked = e.target.checked;

    let updatedSwitchers = switchers.map(el => el.name === name ? { ...el,
      checked: !el.checked
    } : el);
    setSwitchers(updatedSwitchers);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: `formula3dPreview-controls ${isFullScreen ? "fullScreen" : ""}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "formula3dPreview-controls-item"
  }, /*#__PURE__*/React.createElement("img", {
    src: ResetControlsIcon,
    className: "formula3dPreview-controls-item-icon",
    alt: ""
  }), /*#__PURE__*/React.createElement(Button, {
    type: "button",
    color: "primary",
    size: "small",
    variant: "outlined",
    onClick: resetControls
  }, _t("Вид спереди"))), /*#__PURE__*/React.createElement("div", {
    className: "formula3dPreview-controls-item"
  }, /*#__PURE__*/React.createElement("img", {
    src: IconTransparency,
    className: "formula3dPreview-controls-item-icon",
    alt: ""
  }), /*#__PURE__*/React.createElement("span", {
    className: "formula3dPreview-controls-item-title"
  }, _t("Прозрачность")), /*#__PURE__*/React.createElement(Switch, {
    checked: modelTransparency,
    className: "formula3dPreview-controls-item-switch",
    color: "primary",
    name: "model_transparency",
    value: "0",
    onChange: e => {
      setModelTransparency(e.target.checked);
    }
  })), !hideJawStateSwitcher && /*#__PURE__*/React.createElement("div", {
    className: "formula3dPreview-controls-item"
  }, /*#__PURE__*/React.createElement("img", {
    src: IconJawStateOpen,
    className: "formula3dPreview-controls-item-icon",
    alt: ""
  }), /*#__PURE__*/React.createElement("span", {
    className: "formula3dPreview-controls-item-title"
  }, _t("Открыть челюсть")), /*#__PURE__*/React.createElement(Switch, {
    checked: jawState,
    className: "formula3dPreview-controls-item-switch",
    color: "primary",
    name: "jaw_state",
    value: "0",
    onChange: e => {
      toggleJawState(e.target.checked);
    }
  })), !hideHeadMaskSwitcher && /*#__PURE__*/React.createElement("div", {
    className: "formula3dPreview-controls-item"
  }, /*#__PURE__*/React.createElement("img", {
    src: IconHeadMask,
    className: "formula3dPreview-controls-item-icon",
    alt: ""
  }), /*#__PURE__*/React.createElement("span", {
    className: "formula3dPreview-controls-item-title"
  }, _t("Лицо")), /*#__PURE__*/React.createElement(Switch, {
    checked: headMask,
    className: "formula3dPreview-controls-item-switch",
    color: "primary",
    name: "head_mask",
    value: "0",
    onChange: e => {
      toggleHeadMask(e.target.checked);
    }
  })), switchers.map(switcher => /*#__PURE__*/React.createElement("div", {
    className: `formula3dPreview-controls-item ${switcher.hidden ? "hidden" : ""}`,
    key: switcher.name
  }, /*#__PURE__*/React.createElement("img", {
    src: switcher.icon,
    className: "formula3dPreview-controls-item-icon",
    alt: ""
  }), /*#__PURE__*/React.createElement("span", {
    className: "formula3dPreview-controls-item-title"
  }, switcher.label), /*#__PURE__*/React.createElement(Switch, {
    checked: switcher.checked,
    className: "formula3dPreview-controls-item-switch",
    color: "primary",
    name: switcher.name,
    value: "0",
    onChange: onChange
  }))), /*#__PURE__*/React.createElement("div", {
    className: "formula3dPreview-controls-popUpInfo"
  }, _t("Для управления прозрачностью элементами 3D формулы воспользуйтесь переключателями")));
};

export default Formula3DPreviewControls;